const uploadBaseUrl = (process.env.REACT_APP_UPLOAD_BASE_URL || '').trim();

export function resolveUploadUrl(url?: null | string) {
  const value = (url || '').trim();
  if (!value) return '';
  if (/^(data:|https?:\/\/|blob:)/i.test(value)) return value;
  if (value.startsWith('/upload/') && uploadBaseUrl) {
    return `${uploadBaseUrl.replace(/\/$/, '')}${value}`;
  }
  return value;
}
